import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const SavingAPI = (props) => {
 
  return axios.get(
    `${env.HOST}/solusi-masa-depan-anda/simpanan${props}`,
    {
      headers
    }
  );
};
export default SavingAPI;
